"use strict";

export default angular.module("contartemx.administracion.cuentas.detalle", [
  "contartemx",
  "ui.bootstrap",
  "tableTools",
  "loader"
])
  .controller("CuentaDetalleCtrl", ($scope, $rootScope, $state, $stateParams, $cookies, $filter, $uibModal, apiCall, mostrarNotificacion, NgTableParams, SrvAdministracion) => {

    $scope.loading = true;
    $scope.invitarUsuario = {
      mostrarControles: false
    };
    $scope.roles = [];

    const ContarteAPI = new apiCall($scope);
    const paramsIniciales = { count: 10 };

    // Procesar lista de colaboradores
    const procesarColaboradores = r => {
      if (r) {
          if (r.Respuesta && r.CodigoRespuesta == 200) {
          $scope.contribuyente = r.Respuesta.Contribuyente;
          $scope.usuarios = r.Respuesta.Contribuyente.ContribuyentesUsuarios;
          $scope.roles = r.Respuesta.TiposUsuarios;
          $scope.usuarios.forEach(u => {
            let tipoUsuario = $scope.roles.find(tu => tu.CveTipoUsuario == u.CveTipoUsuario);
            u.tipoUsuario = tipoUsuario ? tipoUsuario.Nombre : '';
          });

          if ($scope.tableParams) {
            paramsIniciales.page = $scope.tableParams.page();
            paramsIniciales.sorting = $scope.tableParams.sorting();
          }

          $scope.tableParams = new NgTableParams(paramsIniciales,
            {
              dataset: $scope.usuarios,
              counts: [],
            });

          $scope.loading = false;

        } else {
          mostrarNotificacion[r.EsError ? 'error' : 'info'](r.Mensaje);
        }
      }
    };

    ContarteAPI.post("ObtenerContribuyentePorID", { CveContribuyente: $stateParams.cveContribuyente })
      .then(procesarColaboradores);

    // Modal para invitar colaborador
    $scope.modalInvitarColaborador = () => {
      $scope.loading = true;

      const modalInstance = $uibModal.open({
        template: require('../../../../../app/views/Administracion/Cuentas/Colaboradores/InvitarColaborador_modal.html'),
        controller: 'InvitarColaboradorCtrl',
        windowClass: 'modal--small',
        appendTo: angular.element(document.querySelector('.modal-parent')),
        resolve: {
          roles() {
            return $scope.roles;
            }
        }
      });

      modalInstance.result.then((data) => {
        mostrarNotificacion.info(data.Mensaje);
      }).finally(() => {
        $scope.loading = false;
      });
    };

    $scope.popoverEditarColaborador = {
      template: '../../../../../ng-contartemx/app/views/Administracion/Cuentas/Colaboradores/EditarColaborador_popover.html',
      triggers: 'click outsideClick'
    };

    // Editar rol de colaborador
    $scope.editarColaborador = (usuario) => {
        usuario.CveContribuyente = $stateParams.cveContribuyente;
        if ($scope.contribuyente && $scope.contribuyente.Persona) {
            usuario.Cuenta = {
                Nombre: `${$scope.contribuyente.Persona.Nombre} ${$scope.contribuyente.Persona.ApellidoPaterno} ${$scope.contribuyente.Persona.ApellidoMaterno}`.trim(),
                RFC: $scope.contribuyente.Persona.Rfc
            };
        }
      let modal = SrvAdministracion.ModalEditarColaborador($scope.roles, usuario);
      modal.result.then(procesarColaboradores);
    };

    $scope.popoverEliminarColaborador = {
      template: '../../../../../ng-contartemx/app/views/Administracion/Cuentas/Colaboradores/EliminarColaborador_popover.html',
      triggers: 'click outsideClick'
    };

    // Desactivar colaborador
    $scope.desactivarColaborador = (usuario) => {
      let data = { CveContribuyente: $stateParams.cveContribuyente };
      data.CveUsuario = usuario.ClaveUsuario;
      let modal = SrvAdministracion.ModalDesactivarColaborador(data);
      modal.result.then(procesarColaboradores);
    };

    // Desactivar colaborador con popover
    $scope.eliminarColaborador = (cveUsuario, esUsuarioPendiente) => {

        let data = { CveContribuyente: $stateParams.cveContribuyente };

      data.CveUsuario = cveUsuario;
      data.esUsuarioPendiente = esUsuarioPendiente;

        $scope.loading = true;

        apiCall.post("EliminarColaborador", data)
            .then(procesarColaboradores)
            .finally(() => $scope.loading = false);
    };

    $scope.select = usuario => {
      $scope.deselect();
      usuario.IsSelected = true;
      $scope.usuarioSeleccionado = usuario;
    };

    $scope.deselect = () => {
      $scope.usuarioSeleccionado = null;
      if (angular.isArray($scope.usuarios)) {
        $scope.usuarios.forEach(c => c.IsSelected = false);
      }
    };

  });
